import { agentType } from '../../../utils/variables';

// Treat blank primitives/objects uniformly before reading fallback reducer values.
export const hasUsableValue = value => {
    return !(
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.length === 0) ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0)
    );
};

export const getAgentIdentifier = authState => {
    return authState?.user?.agent?.id || authState?.user?.agent?._id || null;
};

// Supports both legacy usertype checks and agent identity-based checks.
export const isAgentByTypeOrIdentity = authState => {
    return authState?.usertype === agentType || Boolean(getAgentIdentifier(authState));
};

// Strict authenticated-agent check used by client-flow gate logic.
export const isAuthenticatedAgent = (authState, accessToken) => {
    return Boolean(accessToken) &&
        authState?.usertype === agentType &&
        Boolean(getAgentIdentifier(authState));
};